import { render, staticRenderFns } from "./VideoVue.vue?vue&type=template&id=35d86626&scoped=true"
import script from "./VideoVue.vue?vue&type=script&lang=js"
export * from "./VideoVue.vue?vue&type=script&lang=js"
import style0 from "./VideoVue.vue?vue&type=style&index=0&id=35d86626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d86626",
  null
  
)

export default component.exports